import React, { useEffect, useState } from 'react';
import { Post as PostType } from '../../../types';
import ImgProfilePost from '../ImgProfilePost';
import UserName from '../UserName';
import { errorMessage } from '../../../utils/TextManagerTwo';
import OptionsPost from '../OptionsPost';
import ImgPost from '../ImgPost/ImgPost';
import Repost from '../Repost';
import ConfirmationModal from '../../Modals/ConfirmationModal';
import { LIMIT_TEXT_REPORT } from '../../../utils/vars';
import axios from 'axios';
import { useAuth, useTheme } from '../../../global-components/src';
import { useMessage } from '../../../global-components/src';
import { ContainerButtonAds } from '../../container-button-ads/container-button-ads';
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from '../../../global-components/src/utils/vars';
import "./style.css"
import DropdownPost from '../dropdown-post';
import hljs from 'highlight.js';
import 'highlight.js/styles/github-dark.css';
import { YoutubePreview } from '../Post/youtube-preview';
import { PostLinkPreview } from '../Post/post-link-preview';
import { censorText, clearText, extractYouTubeId } from '../../../global-components/src/utils/text';
import { renderTextWithPhoneMessageLinks } from '../../../utils/phone-message-links';
import { Frame } from '../ImgProfilePost/frame';
import PostPoll from '../Post/poll';
import { detectLanguage, isUserLang, translate } from '../../../global-components/src/utils/language';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

interface PostProps {
    post?: PostType;
    setPost: React.Dispatch<React.SetStateAction<PostType | null>>;
    idCommentSelected?: number | null;
    onOpenLikes?: () => void;
    onOpenComments?: () => void;
}

const ViewPost: React.FC<PostProps> = ({ post, setPost, onOpenLikes, onOpenComments, idCommentSelected }) => {
    const [processedText, setProcessedText] = useState<string>("");
    const [repostPostId, setRepostPostId] = useState<number | null>(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showConfirmationReport, setShowConfirmationReport] = useState(false);
    const [postToDelete, setPostToDelete] = useState<PostType | null>(null);
    const [password, setPassword] = useState(''); // Adicione um estado para a senha
    const [errorModal, setErrorModalPassword] = useState(''); // Adicione um estado para a senha
    const [isLoading, setIsLoading] = useState(false); // Adicione um estado para a senha
    const { user, token } = useAuth()
    const { hideCensorship, isNewPacoca, } = useTheme();
    const renderPostText = (text?: string) => {
        if (!text) return "";
        return renderTextWithPhoneMessageLinks(
            !hideCensorship ? censorText(text) : text,
            clearText,
        );
    };
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const [reasonDeletePost, setReasonDeletePost] = useState(''); // Adicione um estado para a senha
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const youtubeId = extractYouTubeId(post?.text ?? "");
    const hasYoutube = Boolean(youtubeId);
    const hasImages = post?.images?.length && post?.images?.length > 0;
    const [oldProcessedText, setOldProcessedText] = useState<string>("");
    const [translatedText, setTranslatedText] = useState<string>("");
    const [isTranslate, setIsTranslate] = useState<boolean>(false);
    const [canTranslate, setCanTranslate] = useState<boolean>(false);
    const language = detectLanguage(post?.text);
    const isTextUserLang = isUserLang(language);

    useEffect(() => {
        if(!isTextUserLang && !post?.gif_url) translateText();
    }, [post?.text]); 

    function handleDeletePost(post: PostType) {
        setPassword("");
        setPostToDelete(post);
        setShowConfirmation(true);
    }

    function handleReportPost(post: PostType) {
        setPassword("");
        setPostToDelete(post);
        setShowConfirmationReport(true);
    }

    const translateText = async(updateText = false) => {
        if(translatedText.length && updateText){
            setProcessedText(translatedText);
            setIsTranslate(true);
            return;
        }

        try {
            let translated = await translate(post?.text);
            if(!translated || post?.text?.trim() == translated.trim()) return;
            translated = renderPostText(translated)
            setTranslatedText(translated)
            
            if(updateText){
                setProcessedText(translated);
                setIsTranslate(true);
            }
            setCanTranslate(true);
        } catch (err: any) {
            console.error('Translation error:', err?.response?.data || err);
            return null;
        }
    }
    

    const showOriginal = async() => {
        setProcessedText(oldProcessedText);
        setIsTranslate(false)
    }

    const onClose = () => {
        setPassword("");
        setShowConfirmation(false)
        setReasonDeletePost("")
    }

    const onCloseReport = () => {
        setPassword("");
        setShowConfirmationReport(false)
        setReasonDeletePost("")
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            hljs.highlightAll();
        }, 20);
        return () => clearTimeout(timeout);
    }, [processedText]);

    const confirmDelete = async (password: string) => {
        const url = PACOCA_API_URL + `/posts/${postToDelete?.id}`;
        setErrorModalPassword("")
        setIsLoading(true)
        try {
            if (user?.id !== postToDelete?.id_user && !password) {
                setErrorModalPassword("Informe sua senha")
                setIsLoading(false)
                return;
            }
            if (user?.id !== postToDelete?.id_user && !reasonDeletePost) {
                setErrorModalPassword("Informe o motivo")
                setIsLoading(false)
                return;
            }
            if (user?.id !== postToDelete?.id_user && (reasonDeletePost?.length <=2 || reasonDeletePost?.toLowerCase() == "regras" || reasonDeletePost?.toLowerCase() == "regra")) {
                setErrorModalPassword("Explique melhor o motivo")
                setIsLoading(false)
                return;
            }

            await axios.delete(url, {
                params: { password, id_post: postToDelete?.id, reason: reasonDeletePost }, // Passa a senha dentro do objeto `data`
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            setShowConfirmation(false)
            setMessage(t("post.deleted"), "success");
            setPassword("");
            window.location.reload()
        } catch (err: any) {
            const messageError = errorMessage(err);
            setErrorModalPassword(messageError)
        } finally {
            setIsLoading(false)
        }
    };


    const confirmRestore = async (password: string) => {
        const url = PACOCA_API_URL + `/posts/restore/${postToDelete?.id}`;
        setErrorModalPassword("")
        setIsLoading(true)
        try {
            if (user?.id !== postToDelete?.id_user && !password) {
                setErrorModalPassword("Informe sua senha")
                setIsLoading(false)
                return;
            }
            if (user?.id !== postToDelete?.id_user && !reasonDeletePost) {
                setErrorModalPassword("Informe o motivo")
                setIsLoading(false)
                return;
            }
            if (user?.id !== postToDelete?.id_user && (reasonDeletePost?.length <=2 || reasonDeletePost?.toLowerCase() == "regras" || reasonDeletePost?.toLowerCase() == "regra")) {
                setErrorModalPassword("Explique melhor o motivo")
                setIsLoading(false)
                return;
            }

            await axios.post(url, { password, id_post: postToDelete?.id, reason: reasonDeletePost }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            setShowConfirmationReport(false)
            setMessage(t("post.restored"), "success");
            setPassword("");
            window.location.reload()
            
        } catch (err: any) {
            const messageError = errorMessage(err);
            setErrorModalPassword(messageError)
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        setProcessedText(renderPostText(post?.text))
        setOldProcessedText(renderPostText(post?.text))
    }, [post?.text]);

    useEffect(() => {
        if(processedText.includes('language')){
             const interval = setInterval(() => {
                hljs.highlightAll();
            }, 20); // roda a cada 20ms
    
            return () => clearInterval(interval); // limpa ao desmontar
        }
        
    }, [processedText]);

    return post?.id ? (
        <>
            <ConfirmationModal
                show={showConfirmation}
                onClose={() => onClose()}
                onConfirm={() => confirmDelete(password)} // Passa a senha aqui
                post={postToDelete}
                title='Excluir Post'
                coverMobile={postToDelete?.id_user != user?.id}
                text={t('post.confirmDelete')}
                requirePassword={postToDelete?.id_user != user?.id}
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={errorModal}
                isLoading={isLoading}
                extraContent={
                    <>
                        {postToDelete?.id_user != user?.id ? (
                            <>
                                <textarea
                                    placeholder='Motivo'
                                    value={reasonDeletePost}
                                    onChange={(e) => setReasonDeletePost(e.target.value)}
                                    className={`mt-3 form-control`}
                                    name="text"
                                    style={{ color: isLimitExceeded ? "red" : "inherit" }}
                                    cols={30} rows={10} />

                                <div className="user-select-none limite-denuncia">
                                    {reasonDeletePost?.length}/{LIMIT_TEXT_REPORT}
                                </div>
                            </>
                        ) : null}
                    </>
                } />
           
            <ConfirmationModal
                idModal='restore-post'
                show={showConfirmationReport}
                onClose={() => onCloseReport()}
                onConfirm={() => confirmRestore(password)} // Passa a senha aqui
                post={postToDelete}
                title='Restaurar Post'
                coverMobile={postToDelete?.id_user != user?.id}
                text={t('post.confirmRestore')}
                requirePassword={postToDelete?.id_user != user?.id}
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={errorModal}
                isLoading={isLoading}
                extraContent={
                    <>
                        {postToDelete?.id_user != user?.id ? (
                            <>
                                <textarea
                                    placeholder='Motivo'
                                    value={reasonDeletePost}
                                    onChange={(e) => setReasonDeletePost(e.target.value)}
                                    className={`mt-3 form-control`}
                                    name="text"
                                    style={{ color: isLimitExceeded ? "red" : "inherit" }}
                                    cols={30} rows={10} />

                                <div className="user-select-none limite-denuncia">
                                    {reasonDeletePost?.length}/{LIMIT_TEXT_REPORT}
                                </div>
                            </>
                        ) : null}
                    </>
                } />


            <div key={`${post?.id}`}>
                <div className="card post-view card-post sem-sombra">
                    <div className={`row row-post ${post.user?.active_frame?.image_path && !post.group_id ? "row-post-with-frame" : ""}`} style={{ flexWrap: "nowrap", overflow: "hidden" }}>
                        {post.user?.active_frame?.image_path && !post.group_id &&
                            <Frame path={`${BUCKET_PACOCA_URL}/${post.user.active_frame?.image_path}`} className="view-post"/>
                        }
                        <ImgProfilePost post={post} />
                        <UserName showContentPost={isNewPacoca} post={post}>
                            {post?.text && !post.gif_url ? (
                                <div className="row row-text-post">
                                    <p
                                        className={`text-post post text-expand text-expand-post-${post?.id}`}
                                        data-post-id={post?.id}
                                        id={`post-${post?.id}`}
                                        dangerouslySetInnerHTML={{ __html: processedText }} // Usa o HTML processado
                                    />

                                    {!isTextUserLang && canTranslate && !isTranslate && (
                                        <span onClick={() => translateText(true)} className='user-select-none text-translate-post'>
                                            <span>{t("post.actions.translate")}</span>
                                        </span>
                                    )}
                                    {!isTextUserLang && canTranslate && isTranslate && (
                                        <span className='user-select-none text-translate-post'>
                                            <span  onClick={showOriginal}>{t("post.actions.untranslate")}</span>
                                        </span>
                                    )}
                                </div>
                            ) : null}

                            {post.gif_url && (
                                <img
                                    src={post.gif_url}
                                    className="post-gif"
                                    alt="GIF"
                                />
                            )}

                            {/* YOUTUBE TEM PRIORIDADE */}
                            {hasYoutube && !hasImages && !post.gif_url && (
                                <YoutubePreview text={post.text} />
                            )}
            
                            {/* LINK PREVIEW SÓ SE NÃO FOR YOUTUBE */}
                            {!hasYoutube && !hasImages && !post.gif_url && (
                                <PostLinkPreview text={post.text} preview={post.link_preview} postId={post.id} />
                            )}
                            <ImgPost img_account={post?.user?.img_account} images={post?.images} post={post} onComment={onOpenComments} onLike={onOpenLikes} onShare={() => setRepostPostId} setPost={setPost} />

                            {post?.original_post_id ? (
                                <Repost onOpenComments={onOpenComments} setPost={setPost} post={post?.original_post} onDelete={() => handleDeletePost(post?.original_post)} onEdit={(post) => post} onReport={() => {}}/>
                            ) : null}

                            {post?.poll && (
                                <PostPoll
                                    poll={post.poll}
                                    postId={post.id}
                                />
                            )}

                            <ContainerButtonAds post={post}/>

                            {!post.deleted_at ? (
                                <OptionsPost setPost={setPost} onOpenComments={onOpenComments} onOpenLikes={onOpenLikes} post={post} onRepost={() => setRepostPostId} />
                            ): null}
                        </UserName>
                        <DropdownPost post={post} onRestore={handleReportPost} onDelete={handleDeletePost} onEdit={setPost}/>
                    </div>

                    {!isNewPacoca ? (
                        <>
                            {post?.text && !post.gif_url ? (
                                <div className="row row-text-post">
                                    <p
                                        className={`text-post post text-expand text-expand-post-${post?.id}`}
                                        data-post-id={post?.id}
                                        id={`post-${post?.id}`}
                                        dangerouslySetInnerHTML={{ __html: processedText }} // Usa o HTML processado
                                    />

                                    {!isTextUserLang && canTranslate && !isTranslate && (
                                        <span onClick={() => translateText(true)} className='user-select-none text-translate-post'>
                                            <span>{t("post.actions.translate")}</span>
                                        </span>
                                    )}
                                    {!isTextUserLang && canTranslate && isTranslate && (
                                        <span className='user-select-none text-translate-post'>
                                            <span  onClick={showOriginal}>{t("post.actions.untranslate")}</span>
                                        </span>
                                    )}
                                </div>
                            ) : null}

                            {post.gif_url && (
                                <img
                                    src={post.gif_url}
                                    className="post-gif"
                                    alt="GIF"
                                />
                            )}

                            {/* YOUTUBE TEM PRIORIDADE */}
                            {hasYoutube && !hasImages && !post.gif_url && (
                                <YoutubePreview text={post.text} />
                            )}
            
                            {/* LINK PREVIEW SÓ SE NÃO FOR YOUTUBE */}
                            {!hasYoutube && !hasImages && !post.gif_url && (
                                <PostLinkPreview text={post.text} preview={post.link_preview} postId={post.id} />
                            )}
                            <ImgPost img_account={post?.user?.img_account} images={post?.images} post={post} onComment={onOpenComments} onLike={onOpenLikes} onShare={() => setRepostPostId} setPost={setPost} />

                            {post?.original_post_id ? (
                                <Repost onOpenComments={onOpenComments} setPost={setPost} post={post?.original_post} onDelete={() => handleDeletePost(post?.original_post)} onEdit={(post) => post} onReport={() => {}}/>
                            ) : null}

                            {post?.poll && (
                                <PostPoll
                                    poll={post.poll}
                                    postId={post.id}
                                />
                            )}

                            <ContainerButtonAds post={post}/>

                            {!post.deleted_at ? (
                                <OptionsPost setPost={setPost} onOpenComments={onOpenComments} onOpenLikes={onOpenLikes} post={post} onRepost={() => setRepostPostId} />
                            ): null}
                        </>
                    ): null}
                </div>
            </div>
        </>
    ) : null;


};

export default ViewPost;
